import React from "react";
import { BsFlagFill } from "react-icons/bs";
import { FaSmile, FaTimes } from "react-icons/fa";

const ContactTickets = ({message, setMessage}) => {
  return (
    <>
      <div className="preview-block">
        <div className="sms-form light">
          <label className="mt-3">Contact</label>
          <div className="to-field">
            <span className="avatar">A</span>
            <span className="name">Abuzer</span>
            <button className="remove-btn">
              <FaTimes />
            </button>
          </div>

          <label className="mt-3">Email Address</label>
          <select className="highlight-select">
            <option>New Email Address</option>
          </select>

          <input
            type="email"
            placeholder="e.g. xyz123@example.com"
            className="mt-2"
          />

          <label className="mt-3">CC Recipients</label>
          <input type="text" placeholder="" />

          <label className="mt-3">Subject</label>
          <input type="text" placeholder="" />

          <label className="mt-3">Message</label>
          <div className="message-wrapper">
            <textarea
              className="message-box"
              placeholder="Type your SMS here..."
              maxLength={160}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />

            <div className="message-tools">
              <button className="icon-btn">
                <FaSmile />
              </button>
              <button className="icon-btn flag">
                <BsFlagFill />
              </button>
            </div>
          </div>

          <div className="message-footer">
            <span>0 / 160 Characters 0 SMS</span>
          </div>

          <label className="mt-3">Attachments</label>
          <input type="file" placeholder="" />

          <label className="mt-3">Tags</label>
          <button className="tag-add">+</button>

          <div className="preview-switcher justify-content-end">
            <button className="px-4" style={{ flex: 0 }}>
              Cancel
            </button>
            <button className="px-4 active" style={{ flex: 0 }}>
              Save
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactTickets;
